import React from 'react'
import { Header } from './pages/Header.js'
import { History } from './pages/History.js'
import { ProductSection } from './pages/ProductSection.js'
import { SeasonalProduct } from './pages/SeasonalProduct.js'
import { HorecaTeaser } from './pages/HorecaTeaser.js'
import { Contact } from './pages/Contact.js'
import { Testimonials } from './pages/Testimonials.js'
import { Seo } from './Seo.js'
import { SiteFooter } from './visualComponent/SiteFooter.js'

export const Landing = () => {
  return (
    <>
        <Seo pageKey="home" />
        <Header />
        <History />
        <ProductSection />
        <SeasonalProduct />
        <HorecaTeaser />
        <Testimonials />
        <Contact />
        <SiteFooter />
    </>
  )
}
